import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/site";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    saveSubmit:  (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),

    /** 根据id查询 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),

    /** 变更实际开工时间 1 - 开工 2 - 完工 */
    changeActualTime: (siteId, type) => axios.get({url: `${PREFIX_URI}/changeActualTime`, data: {siteId: siteId, type: type}}),

    /** 变更项目阶段 */
    changeSitePhase: (siteId, phase) => axios.get({url: `${PREFIX_URI}/changeSitePhase`, data: {siteId: siteId, phase: phase}}),

    /** 查询工地历程 */
    queryHistory: (siteId) => axios.get({url: `${PREFIX_URI}/queryHistory`, data: {siteId: siteId}}),
    /** 查询所有配置 */
    queryAllAttendConfig: () => axios.get({url: `${PREFIX_URI}/queryAllAttendConfig`}),
}